import { useState, useEffect, useMemo } from "react";
import { debounce } from "@mui/material";

const useProductFilter = ({ productsFull, setProducts }) => {
  const [query, setQuery] = useState("");
  const [isMultiSearch, setIsMultiSearch] = useState(false);

  const filterProducts = useMemo(
    () =>
      debounce((query, productsFull) => {
        const isMulti = query.includes(",");
        const terms = isMulti
          ? query.split(",").map((t) => t.trim()).filter(Boolean)
          : [query.trim()];

        const productsFullFiltered = productsFull.filter((item) => {
          return terms.some((term) => {
            let matches = false;

            if (item.hasOwnProperty("item_code")) {
              matches = item.item_code.item_code.includes(term);
            }

            if (!matches) {
              const termLower = term.toLowerCase();
              matches =
                item.name.toString().toLowerCase().includes(termLower) ||
                item.api_description.toString().toLowerCase().includes(termLower);
            }

            return matches;
          });
        });

        if (!productsFullFiltered.length) return;

        setProducts([productsFullFiltered[0], ...productsFullFiltered]);
      }, 300),
    [setProducts],
  );

  useEffect(() => {
    if (query === "" && productsFull.length) {
      setProducts(productsFull);
      setIsMultiSearch(false);
    } else if (query.length > 2) {
      const hasComma = query.includes(",");
      setIsMultiSearch(hasComma);
      filterProducts(query, productsFull);
    }
  }, [query, productsFull, filterProducts, setProducts]);

  const handleQueryChange = (e) => {
    setQuery(e.target.value);
  };

  return { query, isMultiSearch, handleQueryChange };
};

export default useProductFilter;